import Layout from "@/layout/components/NestedView";
var WMS = [{
  path: "demo",
  redirect: "/demo/demo1",
  component: Layout,
  name: "wmsdemo",
  alwaysShow: true,
  meta: {
    title: "测试菜单",
    icon: "user"
  },
  children: [{
    path: "demo1",
    component: function component() {
      return import("@/pages/wms/demo/demo");
    },
    name: "demo1",
    meta: {
      title: "测试菜单"
    }
  }]
}, {
  path: "base",
  redirect: "/base/storage",
  component: Layout,
  name: "base",
  alwaysShow: true,
  meta: {
    title: "基础资料",
    icon: "user"
  },
  children: [{
    path: "storage",
    redirect: "/base/storage/storageList",
    component: Layout,
    name: "baseStorage",
    alwaysShow: true,
    meta: {
      title: "仓库管理"
    },
    children: [{
      path: "storageList",
      component: function component() {
        return import("@/pages/wms/base/storage/storageList");
      },
      name: "storageList",
      meta: {
        title: "仓库列表"
      }
    }, {
      path: "storageAreaList",
      component: function component() {
        return import("@/pages/wms/base/storage/storageAreaList");
      },
      name: "storageAreaList",
      meta: {
        title: "库区列表"
      }
    }, {
      path: "aisleList",
      component: function component() {
        return import("@/pages/wms/base/storage/aisleList");
      },
      name: "AisleList",
      mate: {
        title: "过道列表"
      }
    }]
  }, {
    path: "ruleConfiguration",
    redirect: "/base/ruleConfiguration",
    component: Layout,
    name: "baseRuleConfiguration",
    alwaysShow: true,
    meta: {
      title: "规则配置"
    },
    children: [{
      path: "weiInterRuleCon",
      component: function component() {
        return import("@/pages/wms/base/ruleConfiguration/weiInterRuleCon");
      },
      name: "weiInterRuleCon",
      meta: {
        title: "称重拦截规则配置"
      }
    }]
  }, {
    path: "storageLocation",
    redirect: "/base/storageLocation/storageLocationList",
    component: Layout,
    name: "baseStorageLocation",
    alwaysShow: true,
    meta: {
      title: "库位管理"
    },
    children: [{
      path: "storageLocationList",
      component: function component() {
        return import("@/pages/wms/base/storageLocation/storageLocationList");
      },
      name: "storageLocationList",
      meta: {
        title: "仓库列表"
      }
    }, {
      path: "defaultGoodsList",
      component: function component() {
        return import("@/pages/wms/base/storageLocation/defaultGoodsList");
      },
      name: "defaultGoodsList",
      meta: {
        title: "库位默认商品"
      }
    }]
  }, {
    path: "siteList",
    component: function component() {
      return import("@/pages/wms/base/siteList");
    },
    name: "siteList",
    meta: {
      title: "站点/店铺管理"
    }
  }, {
    path: "productList",
    component: function component() {
      return import("@/pages/wms/base/productList");
    },
    name: "productList",
    meta: {
      title: "产品档案"
    }
  }, {
    path: "newProductList",
    component: function component() {
      return import("@/pages/wms/base/newProductList");
    },
    name: "newProductList",
    meta: {
      title: "新产品档案"
    }
  }, {
    path: "externalProduct",
    component: function component() {
      return import("@/pages/wms/base/externalProduct");
    },
    name: "externalProduct",
    meta: {
      title: "站点产品信息"
    }
  }, {
    path: "skuExternalList",
    component: function component() {
      return import("@/pages/wms/base/skuExternalList");
    },
    name: "skuExternalList",
    meta: {
      title: "外部sku映射"
    }
  }, {
    path: "ownerList",
    component: function component() {
      return import("@/pages/wms/base/ownerList");
    },
    name: "ownerList",
    meta: {
      title: "货主列表"
    }
  }, {
    path: "organizational",
    component: function component() {
      return import("@/pages/wms/base/organizational");
    },
    name: "organizational",
    meta: {
      title: "事业部管理"
    }
  }, {
    path: "supplier",
    component: function component() {
      return import("@/pages/wms/base/supplier");
    },
    name: "supplier",
    meta: {
      title: "供应商管理"
    }
  }, {
    path: "logistics",
    redirect: "/base/logistics",
    component: Layout,
    name: "logistics",
    alwaysShow: true,
    meta: {
      title: "物流管理"
    },
    children: [{
      path: "company",
      component: function component() {
        return import("@/pages/wms/base/logistics/company");
      },
      name: "company",
      meta: {
        title: "物流公司"
      }
    }, {
      path: "mail",
      component: function component() {
        return import("@/pages/wms/base/logistics/mail");
      },
      name: "mail",
      meta: {
        title: "邮寄方式管理"
      }
    }, {
      path: "pkgRuleConfig",
      component: function component() {
        return import("@/pages/wms/base/logistics/pkgRuleConfig");
      },
      name: "pkgRuleConfig",
      mate: {
        title: "PKG渠道合并规则配置"
      }
    }]
  }]
}, {
  path: "in",
  redirect: "/in",
  component: Layout,
  name: "In",
  alwaysShow: true,
  meta: {
    title: "入库管理",
    icon: "user"
  },
  children: [{
    path: "FastCount",
    component: function component() {
      return import("@/pages/wms/in/count/fastCount");
    },
    name: "FastCount",
    meta: {
      title: "快速收货"
    }
  }, {
    path: "weighAny",
    component: function component() {
      return import("@/pages/wms/in/weighBill/weighAny");
    },
    name: "weighAny",
    meta: {
      title: "入库称重"
    }
  }, {
    path: "shelveBill",
    component: function component() {
      return import("@/pages/wms/in/inShelve/shelveBill");
    },
    name: "ShelveBill",
    meta: {
      title: "入库上架"
    }
  }, {
    path: "exceptionTrace",
    name: "exceptionTrace",
    component: function component() {
      return import("@/pages/wms/in/exceptionTrace");
    },
    meta: {
      title: "异常跟踪"
    }
  }, {
    path: "qualityReportTrace",
    name: "qualityReportTrace",
    component: function component() {
      return import("@/pages/wms/in/qualityReportTrace");
    },
    meta: {
      title: "质检报告跟踪"
    }
  }, {
    path: "printBarcode",
    name: "PrintBarcode",
    component: function component() {
      return import("@/pages/wms/in/printBarcode");
    },
    meta: {
      title: "条码打印"
    }
  }, {
    path: "inPurchasePlan/storeTrack",
    component: function component() {
      return import("@/pages/wms/in/inPurchase/storeTrack");
    },
    name: "StoreTrack",
    meta: {
      title: "入库跟踪"
    }
  }, {
    path: "inPurchasePlan",
    redirect: "/in/inPurchasePlan/inspectionAny",
    component: function component() {
      return import( /* webpackChunkName: "Material" */"@/pages/wms/in/inPurchase/inPurchasePlan");
    },
    name: "InPurchasePlan",
    alwaysShow: true,
    meta: {
      title: "采购计划"
    },
    children: [{
      path: "signOrder",
      component: function component() {
        return import("@/pages/wms/in/inPurchase/signOrder");
      },
      name: "SignOrder",
      meta: {
        title: "到货单签收"
      }
    }, {
      path: "arrivalSigningOperation",
      component: function component() {
        return import("@/pages/wms/in/inPurchase/arrivalSigningOperation");
      },
      name: "arrivalSigningOperation",
      meta: {
        title: "到货签收操作"
      }
    }]
  }, {
    path: "inQualityBill",
    redirect: "/in/inQualityBill/inspectionAny",
    component: Layout,
    name: "inQualityBill",
    alwaysShow: true,
    meta: {
      title: "到货质检"
    },
    children: [{
      path: "InspectionAny",
      component: function component() {
        return import("@/pages/wms/in/inQualityBill/inspectionAny");
      },
      name: "InspectionAny",
      meta: {
        title: "大货质检"
      }
    }, {
      path: "InspectionAgain",
      component: function component() {
        return import("@/pages/wms/in/inQualityBill/inspectionAgain");
      },
      name: "InspectionAgain",
      meta: {
        title: "重新质检"
      }
    }, {
      path: "InspectionOnly",
      component: function component() {
        return import("@/pages/wms/in/inQualityBill/inspectionOnly");
      },
      name: "InspectionOnly",
      meta: {
        title: "单件质检"
      }
    }, {
      path: "outsourcedQuality",
      component: function component() {
        return import("@/pages/wms/in/inQualityBill/outsourcedQuality");
      },
      name: "outsourcedQuality",
      meta: {
        title: "代购质检"
      }
    }]
  }, {
    path: "weighingClassification",
    component: function component() {
      return import("@/pages/wms/in/weighingClassification");
    },
    name: "weighingClassification",
    meta: {
      title: "称重分类"
    }
  }, {
    path: "count",
    redirect: "/in/count",
    component: Layout,
    name: "count",
    alwaysShow: true,
    meta: {
      title: "点数"
    },
    children: [{
      path: "PictureCount",
      component: function component() {
        return import("@/pages/wms/in/count/pictureCount");
      },
      name: "PictureCount",
      meta: {
        title: "看图点数"
      }
    }, {
      path: "PrintCodeCount",
      component: function component() {
        return import("@/pages/wms/in/count/printCodeCount");
      },
      name: "PrintCodeCount",
      meta: {
        title: "点数打码"
      }
    }, {
      path: "ScannerCount",
      component: function component() {
        return import("@/pages/wms/in/count/scannerCount");
      },
      name: "ScannerCount",
      meta: {
        title: "扫描点数"
      }
    }, {
      path: "ZeroPoints",
      component: function component() {
        return import("@/pages/wms/in/count/zeroPoints");
      },
      name: "ZeroPoints",
      meta: {
        title: "零采点数"
      }
    }]
  }
  // {
  //   path: "weighBill",
  //   redirect: "/in/weighBill/weighAny",
  //   component: Layout,
  //   name: "weighBill",
  //   alwaysShow: true,
  //   meta: {
  //     title: "称重分类"
  //   },
  //   children: [{
  //     path: "weighAny",
  //     component: () => import("@/pages/wms/in/weighBill/weighAny"),
  //     name: "weighAny",
  //     meta: {
  //       title: "入库称重"
  //     }
  //   }]
  // }
  // {
  //   path: "inShelve",
  //   redirect: "/in/inShelve/shelveBill",
  //   component: Layout,
  //   name: "inShelve",
  //   alwaysShow: true,
  //   meta: {
  //     title: "入库上架"
  //   },
  //   children: [{
  //     path: "shelveBill",
  //     component: () => import("@/pages/wms/in/inShelve/shelveBill"),
  //     name: "shelveBill",
  //     meta: {
  //       title: "上架操作"
  //     }
  //   }]
  // }
  ]
}, {
  path: "acc",
  redirect: "/acc/locationBatchNoStock",
  component: Layout,
  name: "acc",
  alwaysShow: true,
  meta: {
    title: "库存管理",
    icon: "user"
  },
  children: [{
    path: "locationBatchNoStock",
    component: function component() {
      return import("@/pages/wms/acc/locationBatchNoStock");
    },
    name: "ocationBatchNoStock",
    meta: {
      title: "库位SKU批次码库存"
    }
  }, {
    path: "storageStock",
    component: function component() {
      return import("@/pages/wms/acc/storageStock");
    },
    name: "storageStock",
    meta: {
      title: "仓库SKU库存数"
    }
  }, {
    path: "newLocationStock",
    component: function component() {
      return import("@/pages/wms/acc/newLocationStock");
    },
    name: "newLocationStock",
    meta: {
      title: "SKU库位库存"
    }
  }, {
    path: "locationStock",
    component: function component() {
      return import("@/pages/wms/acc/locationStock");
    },
    name: "locationStock",
    meta: {
      title: "库位SKU库存"
    }
  }, {
    path: "locationStockDaily",
    component: function component() {
      return import("@/pages/wms/acc/locationStockDaily");
    },
    name: "locationStockDaily",
    meta: {
      title: "每日库位SKU库存快照"
    }
  }, {
    path: "locationStockMonthly",
    component: function component() {
      return import("@/pages/wms/acc/locationStockMonthly");
    },
    name: "locationStockMonthly",
    meta: {
      title: "每月库位SKU库存结存"
    }
  }]
}, {
  path: "out",
  redirect: "/out/outDeliver",
  component: Layout,
  name: "out",
  alwaysShow: true,
  meta: {
    title: "出库管理",
    icon: "user"
  },
  children: [{
    path: "OrderMessage",
    name: "OrderOrderMessageList",
    component: function component() {
      return import("@/pages/wms/out/orderMessage");
    },
    meta: {
      title: "订单消息"
    }
  }, {
    path: "orderList",
    name: "OrderList",
    component: function component() {
      return import("@/pages/wms/out/orderList");
    },
    meta: {
      title: "订单列表"
    }
  }, {
    path: "pickList",
    component: function component() {
      return import("@/pages/wms/out/outPickList");
    },
    name: "PickList",
    meta: {
      title: "拣货管理"
    }
  }, {
    path: "outPkgBill",
    name: "OutPkgBill",
    component: function component() {
      return import("@/pages/wms/out/outPkgBill");
    },
    meta: {
      title: "PKG管理"
    }
  }, {
    path: "parcelManage",
    component: function component() {
      return import("@/pages/wms/send/parcelManage");
    },
    name: "parcelManage",
    meta: {
      title: "发货跟踪"
    }
  }, {
    path: "collectionTracking",
    name: "collectionTracking",
    component: function component() {
      return import("@/pages/wms/out/collectionTracking");
    },
    meta: {
      title: "揽收追踪"
    }
  }, {
    path: "deliverHandle",
    redirect: "/out/deliverHandle/sowing",
    component: Layout,
    name: "DeliverHandle",
    alwaysShow: true,
    meta: {
      title: "出库操作"
    },
    children: [{
      path: "fastDelivery",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/fastDelivery");
      },
      name: "FastDelivery",
      meta: {
        title: "爆款发货"
      }
    }, {
      path: "distributeSowing",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/distributeSowing");
      },
      name: "DistributeSowing",
      meta: {
        title: "配货播种"
      }
    }, {
      path: "checkVerify",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/checkVerify");
      },
      name: "CheckVerify",
      meta: {
        title: "复核校验"
      }
    }, {
      path: "singleVerify",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/singleVerify");
      },
      name: "SingleVerify",
      meta: {
        title: "单件校验"
      }
    }, {
      path: "crossDockingCheck",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/crossDockingCheck");
      },
      name: "CrossDockingCheck",
      meta: {
        title: "单件越库校验"
      }
    }, {
      path: "weightDelivery",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/weightDelivery");
      },
      name: "WeightDelivery",
      meta: {
        title: "称重发货"
      }
    }, {
      path: "pickingOffShelves",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/pickingOffShelves");
      },
      name: "pickingOffShelves",
      meta: {
        title: "拣货下架"
      }
    }, {
      path: "crossDocking",
      component: function component() {
        return import("@/pages/wms/out/deliverHandle/crossDocking");
      },
      name: "crossDocking",
      meta: {
        title: "单条越库配货"
      }
    }]
  }, {
    path: "parcelException",
    redirect: "/out/parcelException/parcelSplit",
    component: Layout,
    name: "parcelException",
    alwaysShow: true,
    meta: {
      title: "出库异常"
    },
    children: [{
      path: "parcelSplit",
      component: function component() {
        return import("@/pages/wms/out/parcelException/parcelSplit");
      },
      name: "parcelSplit",
      meta: {
        title: "包裹拆包操作"
      }
    }, {
      path: "parcelMerge",
      component: function component() {
        return import("@/pages/wms/out/parcelException/parcelMerge");
      },
      name: "parcelMerge",
      meta: {
        title: "包裹合包操作"
      }
    }, {
      path: "parcelHandle",
      component: function component() {
        return import("@/pages/wms/out/parcelException/parcelHandle");
      },
      name: "ParcelHandle",
      meta: {
        title: "异常处理操作"
      }
    }, {
      path: "logisticHandle",
      component: function component() {
        return import("@/pages/wms/out/parcelException/logisticHandle");
      },
      name: "LogisticHandle",
      meta: {
        title: "包裹物流异常操作"
      }
    }]
  }]
}, {
  path: "inside",
  redirect: "/inside/insideMove",
  component: Layout,
  name: "inside",
  alwaysShow: true,
  meta: {
    title: "库内管理",
    icon: "user"
  },
  children: [{
    path: "insideMove",
    component: function component() {
      return import("@/pages/wms/inside/insideMove");
    },
    name: "insideMove",
    meta: {
      title: "库内移位"
    }
  }, {
    path: "insideReturn",
    component: function component() {
      return import("@/pages/wms/inside/insideReturn");
    },
    name: "insideReturn",
    meta: {
      title: "库内返架"
    }
  }]
}, {
  path: "logistics",
  redirect: "/logistics/packageOperation",
  component: Layout,
  name: "logistics",
  alwaysShow: true,
  meta: {
    title: "物流管理",
    icon: "user"
  },
  children: [{
    path: "packageOperation",
    component: function component() {
      return import("@/pages/wms/logistics/packageOperation");
    },
    name: "packageOperation",
    meta: {
      title: "包裹拆合换"
    }
  }]
}, {
  path: "inventory",
  redirect: "/inventory/plan",
  component: Layout,
  name: "inventory",
  alwaysShow: true,
  meta: {
    title: "盘点管理",
    icon: "user"
  },
  children: [{
    path: "plan",
    component: Layout,
    redirect: "/inventory/plan/planlist",
    name: "inventoryPlan",
    alwaysShow: true,
    meta: {
      title: "盘点计划"
    },
    children: [{
      path: "planlist",
      component: function component() {
        return import("@/pages/wms/inventory/plan");
      },
      name: "inventoryPlanList",
      meta: {
        title: "盘点计划列表"
      }
    }, {
      path: "planadd",
      component: function component() {
        return import("@/pages/wms/inventory/planadd");
      },
      name: "inventoryPlanAdd",
      meta: {
        title: "添加盘点计划"
      }
    }]
  }, {
    path: "task",
    component: Layout,
    redirect: "/inventory/task/tasklist",
    name: "inventoryTask",
    alwaysShow: true,
    meta: {
      title: "盘点任务"
    },
    children: [{
      path: "tasklist",
      component: function component() {
        return import("@/pages/wms/inventory/task");
      },
      name: "inventoryTaskList",
      meta: {
        title: "盘点任务列表"
      }
    }]
  }, {
    path: "confirm",
    component: Layout,
    redirect: "/inventory/confirm/confirmList",
    name: "inventoryConfirm",
    alwaysShow: true,
    meta: {
      title: "盘盈亏确认"
    },
    children: [{
      path: "confirmList",
      component: function component() {
        return import("@/pages/wms/inventory/confirm");
      },
      name: "inventoryConfirmList",
      meta: {
        title: "盘盈亏确认列表"
      }
    }]
  }, {
    path: "profitlossList",
    component: function component() {
      return import("@/pages/wms/inventory/profitloss");
    },
    name: "profitlossList",
    meta: {
      title: "盘点盈亏明细"
    }
  }]
}, {
  path: "allot",
  redirect: "/allot/allotIn",
  component: Layout,
  name: "allot",
  alwaysShow: true,
  meta: {
    title: "调拨管理",
    icon: "user"
  },
  children: [{
    path: "allotIn",
    component: function component() {
      return import("@/pages/wms/allot/allotIn");
    },
    name: "allotIn",
    meta: {
      title: "调拨入库"
    }
  }, {
    path: "allotOut",
    redirect: "/allot/allotOut/allotOutList",
    component: Layout,
    name: "allotOut",
    alwaysShow: true,
    meta: {
      title: "调拨出库"
    },
    children: [{
      path: "allotOutList",
      component: function component() {
        return import("@/pages/wms/allot/allotOut/allotOutList");
      },
      name: "allotOutList",
      meta: {
        title: "调拨出库单"
      }
    }, {
      path: "allotPickOrder",
      component: function component() {
        return import("@/pages/wms/allot/allotOut/allotPickOrder");
      },
      name: "allotPickOrder",
      meta: {
        title: "调拨拣货单"
      }
    }, {
      path: "allotVerify",
      component: function component() {
        return import("@/pages/wms/allot/allotOut/allotVerify");
      },
      name: "allotVerify",
      meta: {
        title: "调拨校验"
      }
    }, {
      path: "inBoxVerify",
      component: function component() {
        return import("@/pages/wms/allot/allotOut/inBoxVerify");
      },
      name: "inBoxVerify",
      meta: {
        title: "装箱校验"
      }
    }, {
      path: "outDelivery",
      component: function component() {
        return import("@/pages/wms/allot/allotOut/outDelivery");
      },
      name: "outDelivery",
      meta: {
        title: "出库发货操作"
      }
    }]
  }]
}, {
  path: "return",
  redirect: "/return/returnHandle",
  component: Layout,
  name: "return",
  alwaysShow: true,
  meta: {
    title: "退件管理",
    icon: "user"
  },
  children: [{
    path: "returnHandle/returnOperate",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnOperate");
    },
    name: "ReturnOperate",
    meta: {
      title: "退件操作"
    }
  }, {
    path: "returnHandle/returnQuality",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnQuality");
    },
    name: "ReturnQuality",
    meta: {
      title: "退件质检"
    }
  }, {
    path: "returnHandle/returnShelveBill",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnShelveBill");
    },
    name: "ReturnShelveBill",
    meta: {
      title: "退件上架"
    }
  }, {
    path: "returnHandle/returnTrack",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnTrack");
    },
    name: "returnTrack1",
    meta: {
      title: "退件跟踪"
    }
  }, {
    path: "returnHandle/returnQualityTask",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnQualityTask");
    },
    name: "ReturnQualityTask1",
    meta: {
      title: "退件质检任务单"
    }
  }, {
    path: "returnHandle/returnLossReport",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnLossReport");
    },
    name: "ReturnLossReport1",
    meta: {
      title: "退件报损明细"
    }
  }, {
    path: "returnHandle/returnWorkload",
    component: function component() {
      return import("@/pages/wms/return/returnHandle/returnWorkload");
    },
    name: "ReturnWorkload1",
    meta: {
      title: "退件工作量统计"
    }
  }]
}, {
  path: "returnGoods",
  redirect: "/returnGoods/purchaseReturn",
  component: Layout,
  name: "returnGoods",
  alwaysShow: true,
  meta: {
    title: "退货管理",
    icon: "user"
  },
  children: [{
    path: "purchaseReturn",
    redirect: "/returnGoods/purchaseReturn/purchaseRefund",
    component: Layout,
    name: "purchaseReturn",
    alwaysShow: true,
    meta: {
      title: "采购退货"
    },
    children: [{
      path: "purchaseRefund",
      component: function component() {
        return import("@/pages/wms/returnGoods/purchaseReturn/purchaseRefund");
      },
      name: "purchaseRefund",
      meta: {
        title: "采购退供退货"
      }
    }]
  }]
}, {
  path: "releaseManagement",
  redirect: "/oprb/releaseManagement",
  component: Layout,
  name: "发布管理",
  alwaysShow: true,
  meta: {
    title: "发布管理",
    icon: "list"
  },
  children: [{
    path: "personalCenter",
    component: function component() {
      return import("@/pages/releaseManagement/personalCenter");
    },
    name: "PersonalCenter",
    meta: {
      title: "个人中心"
    }
  }]
}, {
  path: "report",
  redirect: "/report",
  component: Layout,
  name: "报表管理",
  alwaysShow: true,
  meta: {
    title: "报表管理",
    icon: "list"
  },
  children: [{
    path: "warehousingTobeDone",
    redirect: "/report/warehousingTobeDone",
    component: Layout,
    name: "入库待办",
    alwaysShow: true,
    meta: {
      title: "入库待办"
    },
    children: [{
      path: "toBeReplenish",
      component: function component() {
        return import("@/pages/wms/report/toBeReplenish");
      },
      name: "toBeReplenish",
      meta: {
        title: "待补货"
      }
    }, {
      path: "toBeReceived",
      component: function component() {
        return import("@/pages/wms/report/toBeReceived");
      },
      name: "toBeReceived",
      meta: {
        title: "待收货"
      }
    }, {
      path: "pendingQualityInspection",
      component: function component() {
        return import("@/pages/wms/report/pendingQualityInspection");
      },
      name: "pendingQualityInspection",
      meta: {
        title: "待质检"
      }
    }, {
      path: "tobeWeighed",
      component: function component() {
        return import("@/pages/wms/report/tobeWeighed");
      },
      name: "tobeWeighed",
      meta: {
        title: "待称重"
      }
    }, {
      path: "tobePutOnTheShelf",
      component: function component() {
        return import("@/pages/wms/report/tobePutOnTheShelf");
      },
      name: "tobePutOnTheShelf",
      meta: {
        title: "待上架"
      }
    }]
  }, {
    path: "inboundReport",
    redirect: "/report/inboundReport/receiptHistory",
    component: Layout,
    name: "入库报表",
    alwaysShow: true,
    meta: {
      title: "入库报表"
    },
    children: [{
      path: "receiptHistory",
      component: function component() {
        return import("@/pages/wms/report/receiptHistory");
      },
      name: "receiptHistory",
      meta: {
        title: "收货历史"
      }
    }, {
      path: "cancelReceiptHistory",
      component: function component() {
        return import("@/pages/wms/report/cancelReceiptHistory");
      },
      name: "cancelReceiptHistory",
      meta: {
        title: "取消收货历史"
      }
    }, {
      path: "qualityInspectionHistory",
      component: function component() {
        return import("@/pages/wms/report/qualityInspectionHistory");
      },
      name: "qualityInspectionHistory",
      meta: {
        title: "质检历史"
      }
    }, {
      path: "weighingRecord",
      component: function component() {
        return import("@/pages/wms/report/weighingRecord");
      },
      name: "weighingRecord",
      meta: {
        title: "称重记录"
      }
    }, {
      path: "storageHistory",
      component: function component() {
        return import("@/pages/wms/report/storageHistory");
      },
      name: "storageHistory",
      meta: {
        title: "入库历史"
      }
    }, {
      path: "confessionHistory",
      component: function component() {
        return import("@/pages/wms/report/confessionHistory");
      },
      name: "confessionHistory",
      meta: {
        title: "退供记录"
      }
    }, {
      path: "inspectionUnqualifiedRecord",
      component: function component() {
        return import("@/pages/wms/report/inspectionUnqualifiedRecord");
      },
      name: "inspectionUnqualifiedRecord",
      meta: {
        title: "质检不合格记录"
      }
    }]
  }, {
    path: "attendancePerformance",
    redirect: "/report/attendancePerformance/timeoutRate",
    component: Layout,
    name: "考勤绩效",
    alwaysShow: true,
    meta: {
      title: "考勤绩效"
    },
    children: [{
      path: "timeoutRate",
      component: function component() {
        return import("@/pages/wms/report/timeoutRate");
      },
      name: "timeoutRate",
      meta: {
        title: "各环节超时率"
      }
    }, {
      path: "qualityInspectionPerformance",
      component: function component() {
        return import("@/pages/wms/report/qualityInspectionPerformance");
      },
      name: "qualityInspectionPerformance",
      meta: {
        title: "质检绩效报表"
      }
    }, {
      path: "workloadStatistics",
      component: function component() {
        return import("@/pages/wms/report/workloadStatistics");
      },
      name: "workloadStatistics",
      meta: {
        title: "工作量统计"
      }
    }, {
      path: "cargoDamageRate",
      component: function component() {
        return import("@/pages/wms/report/cargoDamageRate");
      },
      name: "cargoDamageRate",
      meta: {
        title: "货损率"
      }
    }, {
      path: "warehouseQualityInspection",
      component: function component() {
        return import("@/pages/wms/report/warehouseQualityInspection");
      },
      name: "warehouseQualityInspection",
      meta: {
        title: "仓库质检数据报表"
      }
    }, {
      path: "logisticsEfficiency",
      component: function component() {
        return import("@/pages/wms/report/logisticsEfficiency");
      },
      name: "logisticsEfficiency",
      meta: {
        title: "物流能效报表"
      }
    }]
  }, {
    path: "invoicingInventory",
    redirect: "/report/invoicingInventory/stockDetail",
    component: Layout,
    name: "进销存库存",
    alwaysShow: true,
    meta: {
      title: "进销存库存"
    },
    children: [{
      path: "stockDetail",
      component: function component() {
        return import("@/pages/wms/report/stockDetail");
      },
      name: "stockDetail",
      meta: {
        title: "出入库明细报表"
      }
    }, {
      path: "realTimeInAccount",
      name: "RealTimeInAccount",
      component: function component() {
        return import("@/pages/wms/report/realTimeInAccount");
      },
      meta: {
        title: "实时库存台账"
      }
    }, {
      path: "pickingAnalysis",
      name: "pickingAnalysis",
      component: function component() {
        return import("@/pages/wms/acc/locationAnalysis/picking");
      },
      meta: {
        title: "待备货预览"
      }
    }]
  }, {
    path: "outboundReport",
    redirect: "/report/outboundReport/distributionRecord",
    component: Layout,
    name: "出库报表",
    alwaysShow: true,
    meta: {
      title: "出库报表"
    },
    children: [{
      path: "deliverOrderGather",
      component: function component() {
        return import("@/pages/wms/report/deliverOrderGather");
      },
      name: "deliverOrderGather",
      meta: {
        title: "各店铺发货汇总"
      }
    }, {
      path: "distributionRecord",
      component: function component() {
        return import("@/pages/wms/report/distributionRecord");
      },
      name: "distributionRecord",
      meta: {
        title: "配货记录"
      }
    }, {
      path: "verificationRecord",
      component: function component() {
        return import("@/pages/wms/report/verificationRecord");
      },
      name: "verificationRecord",
      meta: {
        title: "校验记录"
      }
    }, {
      path: "parcelWeighingRecord",
      component: function component() {
        return import("@/pages/wms/report/parcelWeighingRecord");
      },
      name: "parcelWeighingRecord",
      meta: {
        title: "包裹称重记录"
      }
    }, {
      path: "allocationCheckRecord",
      component: function component() {
        return import("@/pages/wms/report/allocationCheckRecord");
      },
      name: "allocationCheckRecord",
      meta: {
        title: "调拨校验记录"
      }
    }, {
      path: "shippingdetails",
      component: function component() {
        return import("@/pages/wms/report/shippingdetails");
      },
      name: "shippingdetails",
      meta: {
        title: "发货明细"
      }
    }, {
      path: "pickingRecords",
      component: function component() {
        return import("@/pages/wms/report/pickingRecords");
      },
      name: "pickingRecords",
      meta: {
        title: "拣货记录"
      }
    }]
  }, {
    path: "todointhelibrary",
    redirect: "/report/todointhelibrary/toBeReturned",
    component: Layout,
    name: "库内待办",
    alwaysShow: true,
    meta: {
      title: "库内待办"
    },
    children: [{
      path: "toBeReturned",
      component: function component() {
        return import("@/pages/wms/report/toBeReturned");
      },
      name: "toBeReturned",
      meta: {
        title: "待返架"
      }
    }]
  }]
}, {
  path: "finance",
  redirect: "/finance",
  component: Layout,
  name: "finance",
  alwaysShow: true,
  meta: {
    title: "财务管理",
    icon: "user"
  },
  children: [{
    path: "account",
    component: function component() {
      return import("@/pages/wms/finance/account");
    },
    name: "account",
    meta: {
      title: "账户设置"
    }
  }, {
    path: "rule",
    component: function component() {
      return import("@/pages/wms/finance/rule");
    },
    name: "rule",
    meta: {
      title: "规则设置"
    }
  }, {
    path: "cost",
    component: function component() {
      return import("@/pages/wms/finance/cost");
    },
    name: "cost",
    meta: {
      title: "费用明细"
    }
  }, {
    path: "bill",
    component: function component() {
      return import("@/pages/wms/finance/bill");
    },
    name: "bill",
    meta: {
      title: "账单"
    }
  }, {
    path: "receipt",
    redirect: "/finance/receipt",
    component: Layout,
    name: "receipt",
    alwaysShow: true,
    meta: {
      title: "收款"
    },
    children: [{
      path: "recharge",
      component: function component() {
        return import("@/pages/wms/finance/recharge");
      },
      name: "recharge",
      meta: {
        title: "充值"
      }
    }, {
      path: "deduct",
      component: function component() {
        return import("@/pages/wms/finance/deduct");
      },
      name: "deduct",
      meta: {
        title: "扣款"
      }
    }]
  }, {
    path: "accountFee",
    redirect: "/finance/accountFee",
    component: Layout,
    name: "accountFee",
    alwaysShow: true,
    meta: {
      title: "账号费"
    },
    children: [{
      path: "postal",
      component: function component() {
        return import("@/pages/wms/finance/postal");
      },
      name: "postal",
      meta: {
        title: "邮区"
      }
    }, {
      path: "weight",
      component: function component() {
        return import("@/pages/wms/finance/weight");
      },
      name: "weight",
      meta: {
        title: "重量"
      }
    }, {
      path: "feeConfig",
      component: function component() {
        return import("@/pages/wms/finance/feeConfig");
      },
      name: "feeConfig",
      meta: {
        title: "账号费配置"
      }
    }]
  }]
}, {
  path: "pur",
  component: Layout,
  name: "pur",
  meta: {
    title: "采购管理",
    icon: "el-icon-shopping-cart-full"
  },
  alwaysShow: true,
  children: [{
    path: "purchaseList",
    name: "purchaseList",
    component: function component() {
      return import("@/pages/wms/pur/purchaseList/index");
    },
    meta: {
      title: "采购单管理"
    }
  }]
}];
export default WMS;